import { ProfileMask, ProfileMaskEntity, NewProfileMaskEntity, ActiveMasksEntity } from '../stores/types/masks';
import { getEmbedSafeHeaders } from './auth';
import blpAuth from './blp-auth';
import { getSyncHost } from '../utils/hosts';
import logger from '../utils/logger-rum';

/* ------------------- BEEHIVE SYNC ------------------- */
export const UpsertMaskEntity = (
	room: string | number,
	body: ProfileMaskEntity | NewProfileMaskEntity
) => (
	blpAuth.post({
		url: `/v1/room/${room}/profile-masks/upsert`,
		host: getSyncHost(),
		token: blpAuth.accessToken,
		options: { headers: {'id-token': blpAuth.idToken ?? ''} },
		body,
	}).catch((err) => {
		logger.error('Error', err);
		return null;
	}).then((res) => {
		if (res?.entityValue?.id) {
			return res?.entityValue?.id;
		}
		return null;
	})
);

interface LoadAllMasksResponse {
	profileMasks: Record<string | number, ProfileMask>;
	activeMasksEntity: ActiveMasksEntity;
	profileMaskEntities: Record<number, ProfileMaskEntity>
}

export const LoadMasks = async (
	room: string | number
): Promise<LoadAllMasksResponse> => {
	const headers = getEmbedSafeHeaders();

	const baseState = {
		profileMasks: {},
		activeMasksEntity: {},
		profileMaskEntities: [],
	}

	return await blpAuth.get({
		url: `/v1/room/${room}/profile-masks/list-active`,
		host: getSyncHost(),
		token: blpAuth.accessToken ?? undefined,
		options: { headers }
	}).catch((err) => {
		logger.error('Error', err);
		return baseState;
	}).then((res) => ({
		...baseState,
		...(res ?? {})
	}));
};

export const AttachMask = async (
	room: number,
	maskId: number,
	email: string,
	detach: boolean
) => {
	const res = await blpAuth.post({
		url: `/v1/room/${room}/profile-masks/mutate`,
		host: getSyncHost(),
		token: blpAuth.accessToken,
		options: { headers: {'id-token': blpAuth.idToken ?? ''} },
		body: { maskId, email, detach },
	}).catch((err) => {
		logger.error('Error', err);
		return null;
	});

	if (!res) {
		return null;
	}

	return res;
}

export const FillMaskForInvites = async (
	room: number,
	emails: string[],
) => {
	const res = await blpAuth.put({
		url: `/v1/room/${room}/created-invites/${emails.join(',')}`,
		host: getSyncHost(),
		token: blpAuth.accessToken,
		options: { headers: {'id-token': blpAuth.idToken ?? ''} },
	}).catch((err) => {
		logger.error('Error', err);
		return null;
	});

	if (!res) {
		return null;
	}

	return res;
}